import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('token') && localStorage.getItem('user')) {
            return true;
        }
        else {
            // not logged in so redirect to login page with the return url
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/account/login']);
            return false;

        }
    }
}
